import { STATIC_ASSETS_URL } from 'constants/index';
export function getAssetPath(path, isDarkMode) {
  return "".concat(STATIC_ASSETS_URL, "/assets/featured-collection").concat(isDarkMode ? '/dark' : '', "/").concat(path);
}